import RouteTemplate from 'ember-route-template'
import Component from '@glimmer/component'
import { action } from '@ember/object'
import { queryParam } from 'teacher-ui-client/decorators/query-param'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import {
  serialize as serializeSort,
  deserialize as deserializeSort,
  updateSortColumns,
} from '@blakeelearning/data-tables/utils/sorting'
import { TabGroupComponent } from 'teacher-ui-client/components/tab-group'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { TaskState } from 'teacher-ui-client/components/task-state'
import { BasePageSelector } from 'teacher-ui-client/components/base/page-selector'
import { themeKey } from 'teacher-ui-client/helpers/theme-key'
import { t } from 'ember-intl'
import { TAB_TYPE_KEYS } from 'teacher-ui-client/components/tab-group/tab-types'
import { SkillsMasteredStudentsResults } from 'teacher-ui-client/components/tables/skills-mastered/students-results'

import type ReSkillsMasteredCohortStudentsResultsRoute from 'teacher-ui-client/reporting/ui-scope/re/skills-mastered/cohort/students-results/route'

interface Args {
  model: ModelFor<ReSkillsMasteredCohortStudentsResultsRoute>
}

interface Signature {
  Args: Args
}

export class SkillsMasteredCohortStudentsResultsPage extends Component<Signature> {
  @queryParam('reporting/ui-scope/re/skills-mastered/cohort/students-results') sort!: string

  @queryParam('reporting/ui-scope/re/skills-mastered/cohort/students-results') gradePosition!: number

  get sortingConfig() {
    return deserializeSort(this.sort)
  }

  set sortingConfig(newSortConfig) {
    this.sort = serializeSort(newSortConfig)
  }

  @action
  setGradePosition(gradePosition: number) {
    this.gradePosition = gradePosition
  }

  @action
  updateSort(sortKey: string) {
    this.sortingConfig = updateSortColumns(this.sortingConfig, sortKey)
  }

  <template>
    <TabGroupComponent @theme={{themeKey SubscriptionType.Reading}} @tabType={{TAB_TYPE_KEYS.shadow}} as |tabGroup|>
      <tabGroup.linkToTab @route="reporting.ui-scope.re.skills-mastered.cohort.students-results">
        {{t "reporting.re.skillsMastered.cohort.studentsResults.tabTitle"}}
      </tabGroup.linkToTab>
    </TabGroupComponent>
    <ContentTile class="relative rounded-tl-none print:border-none">
      <div class="bg-oceany-blue-100 h-3"></div>

      <TaskState @task={{@model.fetchStats}} @initialLoadingClass="m-3" as |lastValue isRunning|>
        <SkillsMasteredStudentsResults
          data-test-students-results-table
          class="mt-3"
          @themeKey={{themeKey SubscriptionType.Reading}}
          @studentsData={{lastValue.students}}
          @lessonItemsByGrade={{@model.lessonItemsByGrade}}
          @isLoading={{isRunning}}
          @sortingConfig={{this.sortingConfig}}
          @updateSort={{this.updateSort}}
          @gradePosition={{this.gradePosition}}
          @setGradePosition={{this.setGradePosition}}
          @studentRoute="reporting.ui-scope.re.student-summary.table"
        />
        <BasePageSelector
          class="mx-2 my-3"
          @pageCount={{lastValue.meta.total_pages}}
          @itemCount={{lastValue.meta.total_entries}}
        />
      </TaskState>
    </ContentTile>
  </template>
}

export default RouteTemplate(SkillsMasteredCohortStudentsResultsPage)
